import { Button, Checkbox, ConfigProvider, Form, Input, InputNumber, Modal } from 'antd'
import { useForm } from 'antd/es/form/Form'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'
import ZipCodeSearchField from '../ZipCodeSearchField'
import { ExclamationCircleFilled } from '@ant-design/icons'
const { confirm } = Modal

export default function ComputerAppointmentForm ({ box, onFinishFailed, onFinish, loading }) {
  const { t } = useTranslation()
  const [form] = useForm()
  const [age, setAge] = useState()

  const minimumAge = box?.teleconsulting_company_minimum_age

  const showConfirm = (onOk) => {
    confirm({
      title: t('Public.Appointment.minorConfirmation.title'),
      icon: <ExclamationCircleFilled />,
      content: t('Public.Appointment.minorConfirmation.content', { teleconsultingCompany: box?.teleconsulting_company_name }),
      onOk,
      okText: t('Public.Appointment.minorConfirmation.okText'),
      cancelText: t('Public.Appointment.minorConfirmation.cancelText'),
      width: '600px'
    })
  }

  return (
    <Form
      style={{ fontSize: '1.2em', margin: 'auto', marginTop: '3em', maxWidth: '700px' }}
      id="AppointmentForm"
      form={form}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Form.Item name="first_name" label={t('Public.Appointment.firstName')}
        rules={[{ required: true, message: t('rules.required') }]}>
        <Input />
      </Form.Item>
      <Form.Item name="last_name" label={t('Public.Appointment.lastName')}
        rules={[{ required: true, message: t('rules.required') }]}>
        <Input />
      </Form.Item>
      <Form.Item name="age" label={t('Public.Appointment.age')}
        rules={[
          { required: true, message: t('rules.required') },
          {
            validator: (_, value) => value >= minimumAge ? Promise.resolve() : Promise.reject(new Error(t('Public.Appointment.age_error', { minimumAge })))
          }
        ]}
        extra={t('Public.Appointment.age_extra')} >
        <InputNumber min={0} max={150} value={age} onChange={setAge} />
      </Form.Item>
      <Form.Item name="phone" label={t('Public.Appointment.phone')}
        extra="+33 6 39 98 80 12"
        rules={[
          {
            validator: (_, value) =>
              value ? (isValidPhoneNumber(value) ? Promise.resolve() : Promise.reject(new Error('Numéro incorrect'))) : Promise.reject(new Error(t('rules.required')))
          },
          { required: true, message: t('rules.required') }
        ]}
      >
        <PhoneInput className='phone-large-input ant-input css-dev-only-do-not-override-xfszwz' international defaultCountry={'FR'} placeholder="+33 6 39 98 80 12"
          style={{ maxWidth: '100%' }} />
      </Form.Item>
      <Form.Item name="email" label={t('Public.Appointment.email')} rules={[{ type: 'email', message: t('rules.email') }]} >
        <Input />
      </Form.Item>
      <Form.Item name="postal_place_id" label={t('Public.Appointment.zip_code')} >
        <ZipCodeSearchField form={form} />
      </Form.Item>
      <ConfigProvider theme={{
        token: {
          controlInteractiveSize: 20,
          lineWidth: 2
        }
      }}>
        <Form.Item className="appointment-checkbox" name="cgu" valuePropName="checked"
          rules={[{ validator: (_, value) => value ? Promise.resolve() : Promise.reject(new Error(t('rules.required'))) }]}
        >
          <Checkbox>
            <p>{t('Public.Appointment.cgu_1')} <a target="_blank" href="/cgu" >{t('Public.Appointment.cgu_2')}</a></p>
          </Checkbox>
        </Form.Item>
      </ConfigProvider>
      <Form.Item style={{ textAlign: 'right', marginTop: '3em' }}>
        <Button type="primary" onClick={() => ![undefined, null].includes(age) && age >= minimumAge && age < 18 ? showConfirm(form.submit) : form.submit()} loading={loading} disabled={loading}>
          {t('Public.Appointment.submit')}
        </Button>
      </Form.Item>
    </Form >
  )
}
